import axios from 'axios';

// const baseUrl = process.env.REACT_APP_URL_SERVER;
const baseUrl = process.env.REACT_APP_URL_METIOR;
const apiCode = process.env.REACT_APP_AZURE_CODE;

const Quotations = {
  newClient: {
    create: async (data, userId) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/clientQuotation/${userId}?code=${apiCode}`,
        method: 'POST',
        data,
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },
    get: async (userId) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/clientQuotation/${userId}?code=${apiCode}`,
        method: 'GET',
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },
  },

  existingClient: {
    create: async (data, userId, clientId) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/clients/${userId}?client_id=${clientId}&code=${apiCode}`,
        method: 'POST',
        data,
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },

    get: async (userId, clientId) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/clients/${userId}?client_id=${clientId}&code=${apiCode}`,
        method: 'GET',
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },

    update: async (data, userId, clientId, quotationId) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/clients/${userId}
?client_id=${clientId}&quote_id=${quotationId}&code=${apiCode}`,
        method: 'PUT',
        data,
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },
  },

  user: {
    create: async (data, userId) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/quotation/${userId}?code=${apiCode}`,
        method: 'POST',
        data,
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },

    getFilteredByCategory: async (userId, category) => {
      const response = axios({
        url: `${baseUrl}/api/categories/${userId}?name=${category}&code=${apiCode}`,
        method: 'GET',
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },

    get: async (userId, category) => {
      const response = axios({
        url: `${baseUrl}/api/quotations/quotation/${userId}?name=${category}&code=${apiCode}`,
        method: 'GET',
      })
        .then((res) => res.data)
        .catch((err) => {
          const error = err.response?.data.message || err.toString();
          return { error: { message: error.responseJSON?.message } };
        });
      return response;
    },
  },
};

export default Quotations;
